import { hideHeaderOverlay, showHeaderOverlay } from "Functions/overlay";
import { checkResolution, checkTouchDevice } from "Functions/helpers";
import "Lib/jquery/jquery.menu-aim.js";

const navigation = document.querySelector(".js-aim-navigation");
if (navigation) {
    navigation.firstOpenTimeout = null;
    navigation.afterCloseTimeout = null;
    navigation.openReady = false;

    const onNavTabOpen = () => {
        if (checkResolution("md;lg")) {
            showHeaderOverlay("nav");
        }
    };

    const onNavTabClose = () => {
        requestAnimationFrame(() => {
            if (
                checkResolution("md;lg") &&
                (!navigation.activeTabs || !navigation.activeTabs.length)
            ) {
                hideHeaderOverlay("nav");
            }
        });
    };

    navigation.addEventListener("rTab.after.openTab", (event) => {
        navigation.openReady = true;
        onNavTabOpen();
    });

    navigation.addEventListener("rTab.handleTrigger", (event) => {
        if (checkResolution("md;lg") && event.detail.activeTabs.length) {
            event.preventDefault();
        }
    });

    navigation.addEventListener("rTab.after.closeAllTabs", onNavTabClose);
    navigation.addEventListener("rTab.after.closeTab", (event) => {
        clearTimeout(navigation.afterCloseTimeout);
        onNavTabClose();

        // after closing, do not delay next opening in case you accidentally closed it
        navigation.afterCloseTimeout = setTimeout(() => {
            navigation.openReady = false;
        }, 200);
    });

    navigation.addEventListener("mouseleave", (event) => {
        if (!navigation.activeTabs || !navigation.activeTabs.length) {
            return;
        }

        clearTimeout(navigation.afterCloseTimeout);

        navigation.closeAllTabs();
        navigation.openReady = false;
    });

    navigation.addEventListener("mouseover", (event) => {
        clearTimeout(navigation.afterCloseTimeout);
    });

    $(".js-aim-navigation-main").menuAim({
        enter(row) {
            clearTimeout(navigation.afterCloseTimeout);

            // do not delay hover if tabs are open
            if (navigation.activeTabs && navigation.activeTabs.length) {
                return;
            }

            // if you hover over trigger, delay opening in case you leave trigger immediately
            navigation.firstOpenTimeout = setTimeout(() => {
                navigation.openReady = true;
                this.activate(row);
            }, 300);
        },
        exit() {
            clearTimeout(navigation.firstOpenTimeout);

            navigation.afterCloseTimeout = setTimeout(() => {
                navigation.closeAllTabs();
                navigation.openReady = false;
            }, 200);
        },
        activate(row) {
            if (
                !navigation.openReady ||
                typeof navigation.openTab !== "function" ||
                !checkResolution("md;lg")
            ) {
                return;
            }

            clearTimeout(navigation.afterCloseTimeout);
            navigation.openTab(row.dataset.tabId);
        },
        deactivate(row) {
            if (
                typeof navigation.closeTab !== "function" ||
                !navigation.activeTabs.length ||
                !checkResolution("md;lg")
            ) {
                return;
            }

            navigation.closeTab(row.dataset.tabId);
        },
        rowSelector: ".js-aim-navigation-item",
        submenuDirection: "below",
    });
}

const navigationB2c = document.querySelector(".js-aim-navigation-b2c");

if (navigationB2c) {
    navigationB2c.firstOpenTimeout = null;
    navigationB2c.afterCloseTimeout = null;
    navigationB2c.openReady = false;

    navigationB2c.addEventListener("rTab.handleTrigger", (event) => {
        if (checkResolution("md;lg") && event.detail.activeTabs.length) {
            event.preventDefault();
        }
    });

    $(".js-aim-navigation-b2c-main").menuAim({
        enter(row) {
            // clearTimeout(navigation.afterCloseTimeout)

            // do not delay hover if tabs are open
            if (navigationB2c.activeTabs && navigationB2c.activeTabs.length) {
                return;
            }

            // if you hover over trigger, delay opening in case you leave trigger immediately
            this.activate(row);
        },
        activate(row) {
            if (
                /*!navigation.openReady || */ typeof navigationB2c.openTab !== "function" ||
                !checkResolution("md;lg")
            ) {
                return;
            }

            navigationB2c.openTab(row.dataset.tabId);
        },
        deactivate(row) {
            if (
                typeof navigationB2c.closeTab !== "function" ||
                !navigationB2c.activeTabs.length ||
                !checkResolution("md;lg")
            ) {
                return;
            }

            navigationB2c.closeTab(row.dataset.tabId);
        },
        rowSelector: ".js-aim-navigation-b2c-item",
    });
}

const navigationFeatured = document.querySelector(".js-aim-navigation-featured");

if (navigationFeatured) {
    navigationFeatured.firstOpenTimeout = null;
    navigationFeatured.afterCloseTimeout = null;
    navigationFeatured.openReady = false;

    navigationFeatured.addEventListener("rTab.handleTrigger", (event) => {
        if (checkResolution("md;lg") && event.detail.activeTabs.length) {
            event.preventDefault();
        }
    });

    $(".js-aim-navigation-featured-main").menuAim({
        enter(row) {
            if (navigationFeatured.activeTabs && navigationFeatured.activeTabs.length) {
                return;
            }

            this.activate(row);
        },
        activate(row) {
            if (typeof navigationFeatured.openTab !== "function" || !checkResolution("md;lg")) {
                return;
            }

            navigationFeatured.openTab(row.dataset.tabId);
        },
        deactivate(row) {
            if (
                typeof navigationFeatured.closeTab !== "function" ||
                !navigationFeatured.activeTabs.length ||
                !checkResolution("md;lg")
            ) {
                return;
            }

            navigationFeatured.closeTab(row.dataset.tabId);
        },
        rowSelector: ".js-aim-navigation-featured-item",
    });
}
